<template>
  <div v-if="shipment.description" class="pb-3">
    <div class="child-row-item__title">
      <span> Packing Information </span>
    </div>
    <div class="child-row-item__subtitle">
      <span> {{ shipment.description }} </span>
    </div>
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'PackingInformation',
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
})
</script>
